import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { PageHeader } from '@components/Core/PageHeader';
import BrandTabs from '@components/Core/BrandTabs';
import { AppLoader } from '@components/Core/AppLoader';
import { AddEntityButton } from '@components/Core/AddEntityButton';
import CataloguesTable from '@tables/CataloguesTable/CataloguesTable';
import { Input } from '@inputs/Input';
import { cataloguesTranslations } from './translations';
import { CataloguesTransFields } from './types';

function Catalogues() {
  const { brandId } = useParams();

  const { t } = useMyTranslations<CataloguesTransFields>([cataloguesTranslations.name]);

  const navigate = useNavigate();

  const { isFetching, text } = useGetBrandData();

  const useFormMethods = useForm<{ search: string }>();
  const { watch } = useFormMethods;

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {/* // TODO uncommented after feature will be unfrosted */}
      {/* <BrandTabs currentTab="catalogue list" /> */}
      <div className="flex flex-row justify-between items-center px-[48px] sm-page-padding gap-x-[24px] max-md:gap-x-[12px]">
        <FormProvider {...useFormMethods}>
          <Input name="search" type="text" placeholder={t('search')} />
        </FormProvider>
        <AddEntityButton
          text={t('addCatalogue')}
          onClick={() => navigate(`/brands/${brandId}/add-catalogue`)}
        />
      </div>
      {isFetching ? <AppLoader /> : <CataloguesTable search={watch('search')} />}
    </div>
  );
}

export default Catalogues;
